export const questionsThree = [
  {
    id: 1,
    question:
      "Major is related to Lieutenant in the same way as Squadron Leader is related to...",
    answer: "Flying Officer",
    options: [
      "Group Captain",
      "Flying Attendant",
      "Flying Officer",
      "Pilot Officer",
    ],
    explanations: [
      "Major and Squadron Leader are equivalent ranks in the Army and the Air Force respectively. Same as Lieutenant and Flying Officer are equivalent ranks in the Army and the Air Force.",
    ],
  },
  {
    id: 2,
    question: "Traveller : Journey :: Sailor : ?",
    answer: "Voyage",
    options: ["Water", "Ship", "Voyage", "Crew"],
    explanations: [
      "Second is the name given to the process of travel of the first.",
    ],
  },
  {
    id: 3,
    question:
      "Choose the alternative, which is similar to the given group of words : Kolkata, Munbai, Mangalore",
    answer: "Cochin",
    options: ["Cochin", "Delhi", "Lucknow", "Hyderabad"],
    explanations: ["All are port cities of India."],
  },
  {
    id: 4,
    question: "Choose the odd word.",
    answer: "Potato",
    options: ["Tomato", "Brinjal", "Cucumber", "Potato"],
    explanations: [
      "All the vegetables except potato grow above the ground level.",
    ],
  },
  {
    id: 5,
    question: "Choose the odd Pair.",
    answer: "Pots : Clay",
    options: [
      "Gold : Ornaments",
      "Pots : Clay",
      "Wood : Furniture",
      "Cloth : Garments",
    ],
    explanations: [
      "Except Pots: Clay, in all other pairs, the first is the raw material used to make the second.",
    ],
  },
  {
    id: 6,
    question: "Scurvy is caused due to the deficiency of Vitamin C",
    answer: "True",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "Scurvy is caused by not having enough vitamin C in your diet for at least 3 months.",
    ],
  },
  {
    id: 7,
    question: "India will win the next world cup.",
    answer: "Probable",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "Future can only be predicted not be justified. Hence Probable.",
    ],
  },
  {
    id: 8,
    question:
      "Someone who leaves one country to settle in another is called...",
    answer: "Emigrant",
    options: ["Epicure", "Emigrant", "Cynic", "Traveller"],
    explanations: [
      "Epicure - One who is for the pleasure of eating and drinking.",
      "Emigrant - Someone who leaves one country to settle in another.",
      "Cynic - One who believes that people are motivated purely by self-interest",
      "Traveller - One who often Travels.",
    ],
  },
  {
    id: 9,
    question: "A paper written by hand",
    answer: "Manuscript",
    options: ["Handicraft", "Manuscript", "Handiwork", "Thesis"],
    explanations: [
      "Handicraft - Decorative domestic objects made by hand.",
      "Manuscript - A paper written by hand.",
      "Handiwork - Something that one has made or done.",
      "Thesis - A thesis is a document submitted in support of candidature for an academic degree.",
    ],
  },
  {
    id: 10,
    question: "To cross swords means",
    answer: "To fight",
    options: ["To fight", "To defend", "To kill", "To Rob"],
    explanations: ["Example - The two leaders crossed swords."],
  },
  {
    id: 11,
    question:
      "Pointing to a woman, Suman said, 'Her granddaughter is the only daughter of my brother.' How is the woman related to Suman?",
    answer: "Mother",
    options: ["Sister", "Grandmother", "Mother-in-law", "Mother"],
    explanations: [
      " Daughter of Suman's brother - niece of Suman. Thus the granddaughter of the woman is Suman's niece. Hence, the woman is the mother of Suman.",
    ],
  },
  {
    id: 12,
    question:
      "Suresh introduces a man as “He is the son of the woman who is the mother of the husband of my mother”. How is Suresh related to the man?",
    answer: "Nephew",
    options: ["Uncle", "Son", "Cousin", "Nephew"],
    explanations: [
      "The man is Suresh’s father’s brother. Thus, Suresh is the nephew of that man",
    ],
  },
  {
    id: 13,
    question: "Fossils : Creatures :: Mummies : ?",
    answer: "Human beings",
    options: ["Egypt", "Human beings", "Animanls", "Martyrs"],
    explanations: [
      "Fossils are the remains of Creatures. Similarly, Mummies are the remains of human beings.",
    ],
  },
  {
    id: 14,
    question: "Ocean : Water :: Glacier : ?",
    answer: "Ice",
    options: ["Refrigerator", "Ice", "Mountain", "Cave"],
    explanations: ["First Consists of the second."],
  },
  {
    id: 15,
    question: "King : Throne :: Rider : ?",
    answer: "Saddle",
    options: ["Seat", "Horse", "Saddle", "Chair"],
    explanations: ["A king sits on throne and a rider on a saddle."],
  },
  {
    id: 16,
    question: "ACE : FHJ :: OQS : ?",
    answer: "TVX",
    options: ["PRT", "RTU", "TVX", "UWY"],
    explanations: [
      " Each letter of the first group is moved five steps forward to obtain the corresponding letter of the second group.",
    ],
  },
  {
    id: 17,
    question: "10 : 99 :: 9 : ?",
    answer: "80",
    options: ["69", "80", "97", "49"],
    explanations: ["Subtract one from the square of first to obtain second."],
  },
  {
    id: 18,
    question: "3 : 12 :: 5 : ?",
    answer: "30",
    options: ["25", "35", "30", "15"],
    explanations: ["Square the first and the number itself to obtain second."],
  },
  {
    id: 19,
    question: "'Crocodile tears' means : ",
    answer: "Pretended sorrow",
    options: [
      "Pretended sorrow",
      "Tears of crocodile",
      "Weeping crocodile",
      "Mild regret",
    ],
    explanations: [
      "Example - He has been shedding crocodile tears on behalf of the working men",
    ],
  },
  {
    id: 20,
    question: "'With open arms' means",
    answer: "Warmly",
    options: ["Coldly", "Cold blooded", "Resemble", "Warmly"],
    explanations: [
      "Example - You walk in here and you expect to be welcomed with open arms.",
    ],
  },
  {
    id: 21,
    question:
      "Arrange the given words in alphabetical order and choose the one that comes in second place: Bathing, Banking, Backing, Banishing, Barricading",
    answer: "Banishing",
    options: ["Banking", "Banishing", "Barricading", "Bathing"],
    explanations: [
      "Arranging the words in alphabetical order: Backing, Banishing, Banking, Barricading, Bathing.",
    ],
  },
  {
    id: 22,
    question: "Which will appear fourth in the English Dictionary?",
    answer: "Quit",
    options: ["Quick", "Question", "Quality", "Quit"],
    explanations: [
      "The order of words according to the English dictionary is as follows: Quality, Question, Quick, Quit.",
    ],
  },
  {
    id: 23,
    question:
      "Find the word which cannot be formed by using the letters of the given word : CONSTRUCTION.",
    answer: "CAUTION",
    options: ["SUCTION", "COINS", "CAUTION", "MOTION"],
    explanations: [
      "All the letters except 'A' are present in the main word. Hence, 'CAUTION' cannot be formed from the letters of the given word.",
    ],
  },
  {
    id: 24,
    question:
      "Find the word which cannot be formed by using the letters of the given word : NATIONALISATION.",
    answer: "INSTALLATION",
    options: ["NOTATION", "SALINATION", "INSTALLATION", "SANITATION"],
    explanations: [
      "All the letters except the second 'L' are present in the main word. Hence, 'INSTALLATION' cannot be formed from the letters of the given word.",
    ],
  },
  {
    id: 25,
    question:
      "Select the combination of numbers, so that the letters arranged will form a meaningful word : 1-H, 2-N, 3-R, 4-C, 5-A, 6-B",
    answer: "6,3,5,2,4,1",
    options: ["2,5,3,4,1,6", "3,5,6,4,1,2", "4,1,5,6,2,3", "6,3,5,2,4,1"],
    explanations: [
      "The given letters, when arranged in the order of 6,3,5,2,4,1 form the word BRANCH.",
    ],
  },

  {
    id: 26,
    question:
      "Find the number that does not follow the pattern : 10, 14, 28, 32, 64, 68, 132",
    answer: "132",
    options: ["28", "32", "64", "132"],
    explanations: [
      "The correct pattern is +4, x2, +4, x2..., 10 + 4 = 14, 14 x 2 = 28, 28 + 4 = 32 and so on.",
    ],
  },
  {
    id: 27,
    question: "Find the correct alternatives : _cb_ca_bacb_ca_bac_d",
    answer: "addddb",
    options: ["addddb", "addbbb", "bddddb", "bbbddd"],
    explanations: [
      "The sequence is made of a repetition of two blocks 'acbd' and 'cadb' alternatively.",
    ],
  },
  {
    id: 28,
    question: "Find the next term in the series : A, C, F, J, ?",
    answer: "O",
    options: ["K", "O", "M", "N"],
    explanations: ["A + 2 = C, C + 3 = F, F + 4 = J, J + 5 = O."],
  },

  {
    id: 29,
    question: "ab_d_ _b_dm_ _x_ _",
    answer: "xmaxabdm",
    options: ["xmaxabda", "xmaxabdm", "mxaxabdm", "mxaxbadm"],
    explanations: ["Here, repeated block is 'abxdm'."],
  },
  {
    id: 30,
    question:
      "Seema's younger brother Sohan is older than Seeta. Sweta is younger than Deepti but elder than Seema. Who is the eldest?",
    answer: "Deepti",
    options: ["Seema", "Sweta", "Seeta", "Deepti"],
    explanations: [
      "According to the question, the sequence is as follows : Deepti > Sweta > Seema > Sohan > Seeta",
    ],
  },
  {
    id: 31,
    question:
      "Anil is taller than Sunny and Sunny is shorter than Baby Anil is taller than Bose whose height is less than Sunny Baby is shorter than Anil. Who is the shortest among them?",
    answer: "Bose",
    options: ["Anil", "Baby", "Sunny", "Bose"],
    explanations: [
      "According to the question, the sequence is as follows: Anil > Baby > Sunny > Bose",
    ],
  },
  {
    id: 32,
    question:
      "Barun is taller than Sanjay. Bipul is taller than Barun. Krishna is also not as tall as Bipul but is taller than Barun. Who is the tallest?",
    answer: "Bipul",
    options: ["Barun", "Bipul", "Krishna", "Sanjay"],
    explanations: [
      "The information given in the question may be arranged as follows: Bipul > Krishna > Barun > Sanjay.",
    ],
  },
  {
    id: 33,
    question:
      "N is more intelligent than M. M is not as intelligent as Y. X is more intelligent than Y but not as good as N. Who is the most intelligent of all?",
    answer: "N",
    options: ["N", "M", "X", "Y"],
    explanations: [
      "According to the question : N > M, Y > M, N > X > Y. On arranging the above data, we get : N > X > Y > M.",
    ],
  },
  {
    id: 34,
    question:
      "'Hare' is related to 'Burrow', in the same way 'Owl' is related to...",
    answer: "Barn",
    options: ["Hole", "Hive", "Nest", "Barn"],
    explanations: [
      "'Burrow' is the dwelling place of 'Hare'. Similarly, 'Barn' is the dwelling place of 'Owl'.",
    ],
  },
  {
    id: 35,
    question:
      "In a certain code 'MISSIONS' is written as 'MSIISNOS'. How is 'ONLINE' written in that code?",
    answer: "OLNNIE",
    options: ["OLNNIE", "ONILEN", "NOILEN", " ONNLIE"],
    explanations: [
      "First and the last letter remain the same. The others interchange their positions in pairs of two. So, NL becomes LN, IN become NI so code of ONLINE will be OLNNIE.",
    ],
  },
  {
    id: 36,
    question:
      "In a certain code 'ROAR' is written as 'URDU'. How is 'URDU' written in that code?",
    answer: "XUGX",
    options: ["VXDQ", "XUGX", "ROAR", "VSOV"],
    explanations: [
      "Each letter moves +3. Add 3 to each letter of URDU, so the code of URDU will be XUGX.",
    ],
  },
  {
    id: 37,
    question:
      "Arrange the words in a meaningful order and select the appropriate sequence from the alternatives given below : 1-House, 2-Street, 3-Room, 4-Town, 5-District.",
    answer: "3,1,2,4,5",
    options: ["3,2,1,4,5", "3,1,4,2,5", "3,1,2,4,5", "3,1,2,5,4"],
    explanations: ["Room > House > Street > Town > District."],
  },
  {
    id: 38,
    question:
      "Arrange the words in a meaningful order and select the appropriate sequence from the alternatives given below : 1-Shoulder, 2-Wrist, 3-Elbow, 4-Palm, 5-Finger.",
    answer: "5,4,2,3,1",
    options: ["5,4,2,3,1", "3,4,5,2,1", "3,1,4,2,5", "2,4,5,3,2"],
    explanations: ["Finger > Palm > Wrist > Elbow > Shoulder."],
  },
  {
    id: 39,
    question:
      "How many times are the hands of a clock is at right angle in a day?",
    answer: "44",
    options: ["22", "24", "44", "48"],
    explanations: [
      "In 12 hrs, they are at right angles, 22 times. Hence in 24 hrs, they are at a right angle 44 times.",
    ],
  },
  {
    id: 40,
    question: "How many times do the hand of a clock coincide in a day?",
    answer: "22",
    options: ["24", "22", "21", "20"],
    explanations: ["Hands of a clock coincide 22 times in 24 hrs."],
  },
];
